import { Price } from 'types';

export function priceFactory(params: any = {}): Price {
  const { currencyIso, value } = params;

  return {
    currencyIso: currencyIso || '',
    value: value || 0,
  };
}
